import { useMemo } from 'react'

import { RouteConfig } from '@app/routing/RenderRoutes'

import { Navigate } from '@lib/react-router-dom'

import { useLandingPage } from '@hooks/useLandingPage'

const REMOVED_LEARNING_PAGES = [
  'getting-started',
  'trainings',
  'cqg-education-videos',
  'tutorial-videos',
]

export const useLearningRoutes = (): RouteConfig[] => {
  const { getLandingPage } = useLandingPage()

  return useMemo(
    () => [
      {
        path: 'learning',
        children: REMOVED_LEARNING_PAGES.map((path) => ({
          path,
          element: <Navigate replace to={getLandingPage()} />,
        })),
      },
    ],
    [getLandingPage]
  )
}
